export default __webpack_public_path__ + "static/media/Lapp-logo.499a0a94.png";